module.exports = __webpack_public_path__ + "media/images/gallery/constellations/border_off-4789c47058b7c0e759fc187140247e4c.png";